
import React from 'react';
import { useEmailAuth } from './useEmailAuth';
import { useGoogleAuth } from './useGoogleAuth';
import { useSignOut } from './useSignOut';

interface AuthMethodsProps {
  setIsLoading: (loading: boolean) => void;
  setUser: (user: any) => void;
  setSession: (session: any) => void;
  setIsAdmin: (isAdmin: boolean) => void;
}

export const useAuthMethods = (props: AuthMethodsProps) => {
  const { signIn, signUp } = useEmailAuth(props);
  const { signInWithGoogle } = useGoogleAuth(props);
  const { signOut } = useSignOut(props);

  return {
    signIn,
    signUp,
    signInWithGoogle,
    signOut
  };
};
